module.exports = "arrow-left"